import executeAction from '../utils/executeAction';
import parseLegacyMessageCardActions from '../utils/parseLegacyMessageCardActions';
import registerDefaultActions from '../utils/registerDefaultActions';
import ActionProvider from '../store/schema/ActionProvider';
import ElementDetails from '../store/schema/ElementDetails';

/** All clients share same default action provider.
 * This function add it to theirs */

export default function addDefaultActionProvider(
    actionProviders: ActionProvider[],
    logTelemetryForAction: (actionEventName: string, elementDetails: ElementDetails) => void
): ActionProvider[] {
    let defaultActionProvider: ActionProvider[] = [
        {
            registerActions: () => {
                registerDefaultActions(logTelemetryForAction);
            },
            executeAction: executeAction,
            parseLegacyMessageCardAction: parseLegacyMessageCardActions,
            registerHostCapabilities: null,
        },
    ];
    return defaultActionProvider.concat(actionProviders);
}
